import React, { useReducer, createContext } from 'react';

const prevOrgUserListReducer = (state, action) => {
    return {
        ...state,
        [action?.orgHash]: action?.users,
    };
};

export const PrevOrgUserListContext = createContext();

export const PrevOrgUserListProvider = ({ children }) => {
    const [prevOrgUserListState, prevOrgUserListDispatch] = useReducer(
        prevOrgUserListReducer,
        {
        }
    );

    return (
        <PrevOrgUserListContext.Provider
            value={{ prevOrgUserListState, prevOrgUserListDispatch }}
        >
            {children}
        </PrevOrgUserListContext.Provider>
    );
};
